<template>
  <div class="z-border-red pb-3 pt-1 pl-3 pr-1 ma-1">
    <v-layout wrap>
      <!-- <v-flex class="title mb-2">Credit Card</v-flex> -->

      <v-flex  class="text-xs-right">
        <v-btn fab outline small color="primary" v-if="!value" @click="$emit('onEdit')">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <slot name="status"></slot>

    <slot name="qrstatus"></slot>

    <div class="caption">GB Prime Secret Key</div>
    <div class="form-control" :class="{ 'has-error': errors.has('secretkey') }">
      <template v-if="value">
        <input
          type="text"
          v-model="secretkey"
          v-validate="'required'"
          name="secretkey"
          data-vv-as="Secret Key"
        />
        <span class="text-error" v-if="errors.has('secretkey')">{{
          errors.first('secretkey')
        }}</span>
      </template>
      <div class="primary--text" v-else>
        {{ secretkey ? secretkey : '-' }}
      </div>
    </div>

    <div class="caption mt-2">GB Prime Public Key</div>
    <div class="form-control" :class="{ 'has-error': errors.has('publickey') }">
      <template v-if="value">
        <input
          type="text"
          v-model="publickey"
          v-validate="'required'"
          name="publickey"
          data-vv-as="Public Key"
        />
        <span class="text-error" v-if="errors.has('publickey')">{{
          errors.first('publickey')
        }}</span>
      </template>
      <div class="primary--text" v-else>
        {{ publickey ? publickey : '-' }}
      </div>
    </div>

    <div class="caption mt-2">GB Prime Token</div>
    <div class="form-control" :class="{ 'has-error': errors.has('token') }">
      <template v-if="value">
        <input
          type="text"
          v-model="token"
          v-validate="'required'"
          name="token"
          data-vv-as="Token"
        />
        <span class="text-error" v-if="errors.has('token')">{{ errors.first('token') }}</span>
      </template>
      <div class="primary--text" v-else>
        {{ token ? token : '-' }}
      </div>
    </div>

    <div class="text-xs-center" v-if="value">
      <v-btn color="grey" outline @click="onCancel" v-if="showCancel">
        {{ $t('cancel') }}
      </v-btn>
      <v-btn color="primary" depressed @click="onSave">
        {{ $t('Save') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'gbprime_secretkey', 'gbprime_publickey', 'gbprime_token', 'showCancel'],
  data() {
    return {
      secretkey: '',
      publickey: '',
      token: ''
    }
  },
  mounted() {
    this.secretkey = this.gbprime_secretkey
    this.publickey = this.gbprime_publickey
    this.token = this.gbprime_token
  },
  methods: {
    onCancel() {
      this.$emit('onCancel')
    },
    async onSave() {
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        return false
      }
      this.$emit('onSave', {
        gbprime_secretkey: this.secretkey,
        gbprime_publickey: this.publickey,
        gbprime_token: this.token
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/GbprimeCreditCard.vue